@import '../general';
@import 'link-list';

:host {
  display: block;
}

a {
  @extend .elm-link;
}
